import { StateSchema } from 'app/config/storeConfig/types';
import { Contract } from 'entities/Contract';

export const getContractNoteDrawerState = (state: StateSchema): Nullable<Contract> => state.contractsPage.contractNoteDrawerData;
